<app-text [text]="text()" />
